import {defineStore} from "pinia";
import api from "@/plugins/axios";

export const useServersStore = defineStore('servers', {
    state: () => ({
        items: [],
        item: {},
        metrics: [],
    }),
    actions: {
        async getList() {
            try {
                const {data} = await api.get(`servers`);
                this.items = data;
                return this.items
            } catch (error) {
                console.error('Error fetching:', error);
            }
        },
        async getById(serverId) {
            try {
                const {data} = await api.get(`servers/${serverId}`);
                this.item = data
                return this.item
            } catch (error) {
                console.error('Error fetching details:', error);
            }
        },
        async create(item) {
            try {
                const {data} = await api.post(`servers`, item);
                return data
            } catch (error) {
                console.error('Error creating:', error);
            }
        },
        async getMetrics(filters) {
            try {
                const {data} = await api.get(`servers/metrics`, {params: filters});
                this.metrics = data;
                return this.metrics
            } catch (error) {
                console.error('Error fetching:', error);
            }
        },
    }
})
